import { cloneElement, useId, type ReactElement } from 'react';

type Control = ReactElement<{ disabled?: boolean; 'aria-describedby'?: string }>;

/**
 * An action with the reason it's off shown beside it, never only in a tooltip. Without a reason
 * the action renders as it is.
 */
export function DisabledAction({ reason, children }: { reason?: string; children: Control }) {
  const id = useId();
  if (!reason) return children;
  return (
    <span className="rq-disabled-action">
      <span id={id} className="rq-disabled-reason">
        {reason}
      </span>
      {cloneElement(children, { disabled: true, 'aria-describedby': id })}
    </span>
  );
}
